const RECIPIENT_CATEGORIES = ['STANDARD', 'PRO_AUCTORE', 'PRO_FAMILIA'] as const;

export const getRecipientCategories = (): typeof RECIPIENT_CATEGORIES => {
   return RECIPIENT_CATEGORIES;
};
